<script>
    import { onMount } from "svelte";

    import { fade } from "svelte/transition";

    import {
        getDescriptionByTime,
        getTimeItemsByUnits,
        getTimeUnits,
        updateTimeItems,
    } from "../../../helpers/asaHelper.svelte";

    import { isObjectEmpty } from "../../../../../Utils/utilFunctions.svelte";

    import {
        convertTitleToMin,
        convertTimeRangeInMin,
    } from "../../../helpers/mbsHelper.svelte";

    import {
        addMinutesToTime,
        initTimeObj,
    } from "../../../helpers/encounterHelper.svelte";

    import { amaUnitValue } from "../../../../../stores";

    export let itemProps = {},
        procedureRef,
        selectedItems = [],
        updateItems = () => {};

    // For Item Time Selector
    export let timeObj = {};

    $: maxOptionLength = isInBigRange ? 260 : 14;

    $: isEncounterTypeLabourEpidural = itemProps.billingType == 2;

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: if (
        selectedItems.some((item) => item.itemCode == "Time") &&
        !isWatchingTimeItemSynced
    ) {
        selectedOptionIndex = getTimeItemsByUnits(selectedItems);

        _updateOptionByIndex(selectedOptionIndex);

        isWatchingTimeItemSynced = true;
    }

    let selectedOptionIndex = 0,
        isInBigRange = false;

    let isDefaultTimeItemSynced = false,
        isWatchingTimeItemSynced = false;

    const selectedOption = {
        itemCode: "Time",
        units: Number(0),
        amaUnits: Number(0),
        feeCharged: Number(0), // units * calculationAmount - default 100
        rebateAMA: Number(0), // units * calculationAmount - default 100
        encounterItemDescription: "",
    };

    onMount(() => {
        handleTimeChange();

        setTimeout(() => {
            if (
                selectedItems.some((item) => item.itemCode == "Time") &&
                !isDefaultTimeItemSynced
            ) {
                selectedOptionIndex = getTimeItemsByUnits(selectedItems);

                _updateOptionByIndex(selectedOptionIndex);

                updateItems(updateTimeItems(selectedOption, selectedItems));

                isDefaultTimeItemSynced = true;
            } else isDefaultTimeItemSynced = true;
        }, 0);
    });

    const handleSelectPrev = (index) => {
        let targetIndex = index;

        if (targetIndex < 0) targetIndex = 0;

        if (targetIndex == 0) targetIndex = maxOptionLength - 1;
        else targetIndex -= 1;

        _updateOptionByIndex(targetIndex);

        updateItems(updateTimeItems(selectedOption, selectedItems));

        _syncTimeObj(targetIndex);
    };

    const handleSelectNext = (index) => {
        let targetIndex = index;

        if (targetIndex < 0) targetIndex = 0;

        if (targetIndex == maxOptionLength - 1) targetIndex = 0;
        else targetIndex += 1;

        _updateOptionByIndex(targetIndex);

        updateItems(updateTimeItems(selectedOption, selectedItems));

        _syncTimeObj(targetIndex);
    };

    const handleChangeTime = (e) => {
        _updateOptionByIndex(Number(e.target.value));

        updateItems(updateTimeItems(selectedOption, selectedItems));

        _syncTimeObj(Number(e.target.value));
    };

    const handleToggleRange = () => (isInBigRange = !isInBigRange);

    const handleTimeChange = (func, isFromTimeInput = false) => {
        if (func) func();
        else if (isObjectEmpty(timeObj))
            timeObj = initTimeObj(itemProps, timeObj);
        else if (isFromTimeInput) _syncTimeItemFromTimeInput();
    };
    // HELPER FUNCTIONS
    const _updateOptionByIndex = async (index) => {
        selectedOptionIndex = index;

        if (selectedOptionIndex < 0) selectedOptionIndex = 0;

        const units = getTimeUnits(selectedOptionIndex);
        const feeCharged =
            units *
            (itemProps.shouldUseDynamicAmaRates
                ? itemProps.currentCalculationAmount
                : $amaUnitValue);
        const description = await getDescriptionByTime(selectedOptionIndex);

        selectedOption.units = units;
        selectedOption.amaUnits = units;
        selectedOption.feeCharged = Number(feeCharged);
        selectedOption.rebateAMA = Number(feeCharged);
        selectedOption.encounterItemDescription = description;
    };

    const _syncTimeItemFromTimeInput = () => {
        if (isObjectEmpty(timeObj)) return;

        const { startTime, endTime } = timeObj;

        if (!startTime || !endTime) return;

        const formatStartTime = `1900-01-01T${startTime}`;
        // if endTime < startTime then take  endTime as next day
        const formatEndTime =
            endTime < startTime
                ? `1900-01-02T${endTime}`
                : `1900-01-01T${endTime}`;

        const timeDiff = convertTimeRangeInMin(formatStartTime, formatEndTime);

        const targetTimeItemIndex = _getTimeItemIndex(timeDiff);

        _updateOptionByIndex(Number(targetTimeItemIndex));

        updateItems(updateTimeItems(selectedOption, selectedItems));
    };

    const _syncAdditionalProcedureItems = () => {
        const { billingType, neuraxialType } = itemProps;

        if (billingType != 2 || !neuraxialType || isObjectEmpty(timeObj))
            return;

        const { startTime, endTime } = timeObj;

        if (!startTime || !endTime) return;

        const formatStartTime = `1900-01-01T${startTime}`;
        // if endTime < startTime then take  endTime as next day
        const formatEndTime =
            endTime < startTime
                ? `1900-01-02T${endTime}`
                : `1900-01-01T${endTime}`;

        const item =
            neuraxialType == 1
                ? { key: 1, value: "Insertion" }
                : neuraxialType == 2
                  ? { key: 2, value: "Top up | Revision" }
                  : null;

        itemProps.startDate = formatStartTime;
        itemProps.endDate = formatEndTime;

        procedureRef.handleSelectItem(item, false);
    };

    const _syncTimeObj = (index) => {
        if (isObjectEmpty(timeObj)) return;

        const { startTime, endTime } = timeObj;

        if (!startTime && !endTime) return;

        let description = getDescriptionByTime(index);

        const totalMins = convertTitleToMin(description)[1];

        if (startTime) timeObj.endTime = addMinutesToTime(startTime, totalMins);
        else timeObj.startTime = addMinutesToTime(endTime, -totalMins);
    };

    const _getTimeItemIndex = (timeDiff) => {
        if (timeDiff <= 120) return Math.ceil(timeDiff / 15) - 1;
        else if (timeDiff <= 240)
            return 8 + Math.ceil((timeDiff - 120) / 10) - 1;
        else return 20 + Math.ceil((timeDiff - 240) / 5) - 1;
    };
</script>

<div
    class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4"
    transition:fade={{ duration: isCardiacEncounter ? 100 : 0 }}
>
    <div class="flex flex-1 items-center">
        <p class="w-auto min-w-[6rem] font-bold text-lg">
            Time {itemProps.itemType == "quote" ? "for quote" : ""}
        </p>
    </div>

    {#if !isEncounterTypeLabourEpidural}
        <div class="flex flex-1 items-center justify-between">
            <p>
                {selectedOption.encounterItemDescription
                    ? selectedOption.encounterItemDescription
                    : "No time range selected"}
            </p>

            <div class="flex items-center gap-x-2">
                <button
                    class="btn btn-secondary btn-sm text-[#fff]"
                    on:click|preventDefault={() =>
                        handleTimeChange(handleSelectPrev(selectedOptionIndex))}
                >
                    <i class="fa faIcon">&#xf104;</i>
                </button>

                <button
                    class="btn btn-secondary btn-sm text-[#fff]"
                    on:click|preventDefault={() =>
                        handleTimeChange(handleSelectNext(selectedOptionIndex))}
                >
                    <i class="fa faIcon">&#xf105;</i>
                </button>
            </div>
        </div>

        <div class="flex flex-1 flex-col px-4">
            <input
                type="range"
                class="range range-secondary"
                min="0"
                max={Number(maxOptionLength - 1)}
                value={selectedOptionIndex}
                step="1"
                on:input|preventDefault={(e) =>
                    handleTimeChange(handleChangeTime(e))}
            />
        </div>

        <div class="flex flex-1 items-center justify-end">
            <p
                class="text-secondary underline cursor-pointer"
                on:click|preventDefault={handleToggleRange}
            >
                show {isInBigRange ? "Short" : "Long"} Range
            </p>
        </div>
    {/if}

    {#if itemProps.itemType == "invoice"}
        <div class="flex flex-1 items-center gap-x-8">
            <div class="flex items-center gap-x-2">
                <p class="text-md">Start Time:</p>
                <input
                    type="time"
                    class="input input-sm input-bordered"
                    bind:value={timeObj.startTime}
                    on:change={() => handleTimeChange(undefined, true)}
                    on:blur={_syncAdditionalProcedureItems}
                />
            </div>
            <div class="flex items-center gap-x-2">
                <p class="text-md">End Time:</p>
                <input
                    type="time"
                    class="input input-sm input-bordered"
                    bind:value={timeObj.endTime}
                    on:change={() => handleTimeChange(undefined, true)}
                    on:blur={_syncAdditionalProcedureItems}
                />
            </div>
        </div>
    {/if}
</div>
